import React from 'react'

const Footer = () => {
    return (
        <footer className="footer text-center p-4 bg-[#F5F5F5] sticky top-[100vh]">
            <p className='text-xs mx-auto'>Copyright © STAINAA 2023 All right reserved Free Coding</p>
        </footer>
    )
}

export default Footer